import { render } from "./RecoveringPassword.vue?vue&type=template&id=4145c2ea"
import script from "./RecoveringPassword.vue?vue&type=script&lang=js"
export * from "./RecoveringPassword.vue?vue&type=script&lang=js"

import "./RecoveringPassword.vue?vue&type=style&index=0&id=4145c2ea&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__